import { __ } from '@/utils/utils'

import type { RouteRecordRaw } from 'vue-router'

export const companyRoutes: RouteRecordRaw = {
  path: '/:lang?/company',
  props: (route) => ({ lang: route.params.lang || 'en' }),
  component: () => import('@/Company/layouts/DefaultLayout.vue'),
  children: [
    {
      path: '',
      name: 'company',
      component: () => import('@/Company/views/ContactUsView.vue'),
      meta: {
        breadcrumbLabel: { parent: 'Company', child: '_Contact us' },
        breadcrumbRoute: 'company/'
      }
    },
    {
      path: 'contact-us/',
      name: 'contact-us',
      meta: {
        breadcrumbLabel: { parent: 'Company', child: '_Contact us' },
        breadcrumbRoute: 'company/'
      },
      component: () => import('@/Company/views/ContactUsView.vue')
    },
    {
      path: 'about-us/',
      name: 'about-us',
      meta: {
        breadcrumbLabel: { parent: 'Company', child: 'About us' },
        breadcrumbRoute: 'company/'
      },
      component: () => import('@/Company/views/AboutUsView.vue')
    }
  ]
}
